import { ADD_MD } from './actionTypes';
import { md } from '../utils/md';
export const addMdFromUserAgent = (userAgent) => (dispatch) => {
    const mdInfo = md.detect(userAgent);
    return dispatch({
        type: ADD_MD,
        payload: mdInfo,
    });
};
